module.exports = __webpack_public_path__ + "img/checkbox_off.671624f6.svg";